import React from "react";

const ProgressBar = (props) => {
  const { completed, backWidth } = props;

  const containerStyles = {
    width: `${backWidth}px`,
    height: "10px",
    backgroundColor: "#000000",
    border: "1px solid #2F2323",
    borderRadius: 50,
  };

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    background: `linear-gradient(to right,  #f89825,  #f26322,  #e5333b, #c81d5e,  #a91e5e)`,
    borderRadius: "inherit",
    textAlign: "right",
  };

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;
